import { useState, type FormEvent } from "react";
import { useAuth } from "./AuthProvider";
import { useRpc } from "@/lib/useRpc";
import { Boton, Campo, Input, Select } from "@/components/ui";
import { Logo } from "@/components/layout/Logo";

/** El usuario entró pero no pertenece a ninguna empresa: crea la suya. */
export function Onboarding() {
  const { recargarPerfil, salir, session } = useAuth();
  const [empresa, setEmpresa] = useState("");
  const [nombre, setNombre] = useState("");
  const [modo, setModo] = useState<"erp" | "manual">("manual");
  const crear = useRpc("crear_empresa", { onSuccess: () => recargarPerfil() });

  function enviar(e: FormEvent) {
    e.preventDefault();
    crear.mutate({ p_nombre_empresa: empresa, p_nombre_usuario: nombre, p_modo_ventas: modo });
  }

  return (
    <main className="flex min-h-full items-center justify-center bg-fondo p-6">
      <form onSubmit={enviar} className="w-full max-w-md rounded-lg border border-borde bg-white p-8">
        <div className="mb-6 flex items-center gap-3">
          <Logo className="h-10 w-10" />
          <div>
            <h1 className="text-xl font-bold">Crea tu empresa</h1>
            <p className="text-sm text-tinta-suave">Entraste como {session?.user.email}</p>
          </div>
        </div>
        <div className="space-y-4">
          <Campo etiqueta="Nombre de la empresa" htmlFor="empresa">
            <Input id="empresa" required value={empresa} onChange={(e) => setEmpresa(e.target.value)} placeholder="Abastos El Progreso" />
          </Campo>
          <Campo etiqueta="Tu nombre" htmlFor="nombre" ayuda="Así aparecerás en los conteos y movimientos que registres.">
            <Input id="nombre" required value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Juan Pérez" />
          </Campo>
          <Campo etiqueta="¿Tus ventas se registran en un sistema (ERP o punto de venta)?" htmlFor="modo"
            ayuda={modo === "erp" ? "Aquí no capturas ventas; importas tu inventario del sistema y cuentas." : "Aquí registras las ventas del día en bloque y EYE IA es tu inventario."}>
            <Select id="modo" value={modo} onChange={(e) => setModo(e.target.value as "erp" | "manual")}>
              <option value="manual">No, lo llevo en Excel o a mano</option>
              <option value="erp">Sí, tengo ERP o punto de venta</option>
            </Select>
          </Campo>
          {crear.error && <p className="text-sm text-error" role="alert">{crear.error.mensaje}</p>}
          <Boton type="submit" className="w-full" tamano="lg" cargando={crear.isPending}>Crear empresa</Boton>
          <button type="button" onClick={salir} className="w-full text-sm text-tinta-suave underline">Salir</button>
        </div>
      </form>
    </main>
  );
}
